import {Theme} from "engage-client/theme";


export function MCColors(theme:Theme){
	return [theme.multipleChoice.multipleChoiceColors.first, theme.multipleChoice.multipleChoiceColors.second,
		theme.multipleChoice.multipleChoiceColors.third,theme.multipleChoice.multipleChoiceColors.fourth];
}
export function MCDisabledColor(theme:Theme) {return theme.multipleChoice.multipleChoiceColors.disabled;}
export const MCHeightLg = 95;
export const MCHeightSm = 75;
export enum AnswerStatus {
	unknown, //before the answer is revealed
	incorrect,
	correct
}